/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react"
import { create年号西暦一覧, T年号西暦一覧 } from "../../ts/util/dateUtil"
import BaseComboBox, { TExtendedBaseComboBoxProps } from "./BaseComboBox"

// コンボボックスでの表示対象となるアイテムの型定義をここに記載
type TItem = Partial<T年号西暦一覧> & {
  displayMemberPath: string
}

export type T年ComboBoxItem = TItem

// コンボボックスの表示名とするプロパティ名
const displayField: keyof TItem = "displayMemberPath"

// コンボボックスの選択値となるプロパティ名
const valueField: keyof TItem = "西暦"

// 全選択の選択用アイテム生成処理
const createAllSelectItem = () => {
  const obj = {} as TItem
  // 全選択の表示名
  obj[displayField] = `すべて`
  // 全選択時の値
  obj[valueField] = undefined
  return obj
}

// 未選択用のアイテム生成処理
const createEmptyItem = () => {
  const obj = {} as TItem
  // 全選択の表示名
  obj[displayField] = ``
  // 全選択時の値
  obj[valueField] = undefined
  return obj
}

const 年号西暦一覧 = create年号西暦一覧()

/**
 *
 * @param props
 * @returns
 */
export const YearComboBox: React.FC<
  TExtendedBaseComboBoxProps<number | undefined, TItem> & {
    isShow和暦?: boolean
    is年度: boolean
  }
> = (props) => {
  // state
  const [innerItemsSource, setInnerItemsSource] = useState<Array<TItem>>([
    ...年号西暦一覧.map((d) => {
      // show和暦を確認し、表示内容を調整する
      const displayMemberPath = props.isShow和暦
        ? d.displayMemberPath
        : d.西暦?.toString()
        ? d.西暦.toString() + "年"
        : ""
      return {
        和暦: d.和暦,
        西暦: d.西暦,
        // is年度に合わせて表示を変える
        displayMemberPath: props.is年度
          ? displayMemberPath.replaceAll("年", "年度")
          : displayMemberPath,
      }
    }),
  ])

  // 初期値がある場合の設定処理
  const setDefaultValue = (data: TItem[]) => {
    if (props.defaultValue) {
      const firstData = data.find((d) => {
        return d[valueField] === props.defaultValue
      })
      if (firstData != null) {
        props.setText && props.setText(firstData[displayField] ?? "")
        props.setSelectedItem && props.setSelectedItem(firstData)
        props.setSelectedValue && props.setSelectedValue(firstData[valueField])
      }
    }
  }

  // 初期設定
  useEffect(() => {
    // itemsSource検索開始フラグ
    if (
      props.itemsSource != null &&
      props.ComboBox != null &&
      props.isLoadEnded === false
    ) {
      const data = (
        props.itemsSource ?? [
          ...年号西暦一覧.map((d) => {
            // show和暦を確認し、表示内容を調整する
            const displayMemberPath = props.isShow和暦
              ? d.displayMemberPath
              : d.西暦?.toString()
              ? d.西暦.toString() + "年"
              : ""
            return {
              和暦: d.和暦,
              西暦: d.西暦,
              // is年度に合わせて表示を変える
              displayMemberPath: props.is年度
                ? displayMemberPath.replaceAll("年", "年度")
                : displayMemberPath,
            }
          }),
        ]
      ).filter(props.listFilter ? props.listFilter : () => true)
      if (props.isAllSelect) {
        data.splice(0, 0, createAllSelectItem())
      } else if (props.isEmpty) {
        data.splice(0, 0, createEmptyItem())
      }

      setInnerItemsSource(data)
      setDefaultValue(data)

      props.setIsLoadEnded(true)
    }
  }, [props.itemsSource, props.ComboBox, props.isLoadEnded, props.is年度])

  // 必要項目を渡したBaseAutoCompleteを返却
  return (
    <>
      <BaseComboBox
        displayField={displayField}
        valueField={valueField}
        {...props}
        itemsSource={innerItemsSource}></BaseComboBox>
    </>
  )
}
